export type PipDefaultAnchor =
	| "bottom-left"
	| "bottom-right"
	| "top-left"
	| "top-right";

export interface PipSnapConfig {
	edgePaddingPx: number;
	cornerSnapRadiusPx: number;
	snapTransitionMs: number;
	/** Corner used on first layout and {@link UseFloatingPipDragResult.resetToDefault}. */
	defaultAnchor?: PipDefaultAnchor;
}

export const DEFAULT_PIP_SNAP_CONFIG: PipSnapConfig = {
	edgePaddingPx: 16,
	cornerSnapRadiusPx: 72,
	snapTransitionMs: 280,
};

export function resolvePipSnapConfig(
	partial?: Partial<PipSnapConfig>,
): PipSnapConfig {
	return {
		...DEFAULT_PIP_SNAP_CONFIG,
		...partial,
	};
}
